import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum ConfirmationStatusEnum {
    VisitConfirmed = 1,
    ResceduleVisit = 2,
    CalledPatient = 3
}

export class ConfirmationStatusEnumClass extends EnumWithDescription<ConfirmationStatusEnum> {
    public readonly enum = ConfirmationStatusEnum;
    public readonly enumName: string = "ConfirmationStatus";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<ConfirmationStatusEnum>> = new Map([
        [
            "VisitConfirmed",
            {
                value: ConfirmationStatusEnum.VisitConfirmed,
                name: "Visit Confirmed"
            }
        ],
        [
            "ResceduleVisit",
            {
                value: ConfirmationStatusEnum.ResceduleVisit,
                name: "Call To Reschedule"
            }
        ]
    ]);
}

export const ConfirmationStatus = new ConfirmationStatusEnumClass();
